<script>
export default {
  name: "ExternalProviderButton",
};
</script>

<template>
  <button type="button">
    <slot name="icon" />
    <slot name="text" />
  </button>
</template>

<style scoped lang="scss">
button {
  all: unset;
  padding: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border-radius: 8px;
  border: 1px solid #e2e4e9;
  flex: 1;
  cursor: pointer;

  &:hover {
    border-color: var(--theme-color-primary);
    color: var(--theme-color-primary);
  }
}
</style>
